import script from "./A_Propos.vue?vue&type=script&setup=true&lang=js"
export * from "./A_Propos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__